import { render, staticRenderFns } from "./ToolbarHeader.vue?vue&type=template&id=4d136013&scoped=true"
import script from "./ToolbarHeader.vue?vue&type=script&lang=js"
export * from "./ToolbarHeader.vue?vue&type=script&lang=js"
import style0 from "./ToolbarHeader.vue?vue&type=style&index=0&id=4d136013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d136013",
  null
  
)

export default component.exports